import { ChangeEvent, useState } from "react";
import { Button, Checkbox, Colors } from "@blueprintjs/core";
import { styled } from "styled-components";
import { Box, CustomCard } from "ui-components";
import useSession from "ui-io/use-session";
import InputField from "../input-field";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  const { isAuthenticated, login } = useSession();
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState({
    isLoggedIn: false,
    username: "",
    password: "",
  });


  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const userObj: any = { ...userDetail };
    if (name) userObj[name] = value;
    setUserDetail({ ...userObj });
  };

  const onSubmitLogin = () => {
    if (userDetail.username === "rahul" && userDetail.password === "0000") {
      if (login) {
        login({
          token: "qwqwq",
          userId: "1234",
          username: "rahul",
          isAuthenticated: true,
        });
      }
    }
  };

  return (
    <Box flexDir="row" justify="between"  mt={"large"} items="center" height={"1"}>
      <Box>
        <BannerContent> The startup discovery engine</BannerContent>
        <BannerContent isDark={true}> Find your fund returners</BannerContent>
        <img
          src="/images/login-banner.svg"
          alt="Login Banner"
          className="mt-xxlg"
        />
      </Box>
    
        <CustomCard maxWidth="400px" marginTop="0px">
          <div className="pt-xxlg pb-xxlg pl-md pr-md mt-md mb-md">
            <div className="fs-26 fw-bold">Sign In</div>
            <div className="mt-md fs-13">
              Enter your email and password to sign in!
            </div>

            <InputField
              label={"Email"}
              name={"username"}
              type={"text"}
              placeholder="mail@simple.com"
              onChange={handleOnChange}
              value={userDetail?.username ?? ""}
            />

            <InputField
              label={"Passworrd"}
              name={"password"}
              type={"password"}
              placeholder="Min. 8 characters"
              onChange={handleOnChange}
              value={userDetail?.password ?? ""}
            />

            <div className="mt-lg fs-10 display-flex justify-between"> <Checkbox checked={false} label="Keep me logged in" onChange={()=>{} } /> <a>Forgot password?</a></div>
            <Button className="w-100" onClick={onSubmitLogin}>
              Sign In
            </Button>
            <div className="display-flex align-center mt-md mb-md"><CustomHr />&nbsp;Or&nbsp;<CustomHr/></div>
            <div className={"mt-sm mb-sm fs-10 display-flex justify-between"}>
              <span>continue with Google</span>{" "}
              <span>continue with Facebook</span>
            </div>
            <div className={"mt-md fs-13"}>
              <span>Click here to </span>
              <a
                className={"classes.haveAccountLogin"}
                onClick={() => {
                  navigate("/sign-up");
                }}
              >
                Create an account
              </a>
            </div>
          </div>
        </CustomCard>
    </Box>
  );
};
export default SignIn;

const BannerContent = styled.div<{ isDark?: boolean }>`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.3em;
  color: ${({ isDark, theme: { darkMode } }) =>
    isDark
      ? darkMode
        ? Colors.LIGHT_GRAY5
        : Colors.BLACK
      : darkMode
        ? Colors.LIGHT_GRAY1
        : Colors.GRAY3};
`;
const CustomHr = styled.hr`
width: 100%;
    height: 1px;
`